import { InterviewsService } from "../../../../services/interviews.service";
import { DownloadExcelCommand } from "../../../../shared/commands/download-excel-command";
import { DownloadDeletedCommand } from "../../../../shared/commands/download-deleted-command";
import { TableStructure } from "../../../records/models/table-structure";
import { InterviewSummary } from "../models/interview-summary";
import { MeUser, userHasCsiProfile } from "../../../../services/models/me-user";
import { IPayload, IQuestion } from "../../../../interface/filters";
import { getColumns } from "./interview-summary-table-columns/interview-summary-table-config-columns";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";
import { UploadExcelCommand } from "src/app/shared/commands/upload-excel-command";
import { DownloadLogService } from "src/app/services/download-log.service";

const DOWNLOAD_DELETED_SECTIONS : string[]= []; //['SALES', 'AFTERSALES', 'SHOPPER'];

export const genInterviewSummaryTableConfig = (service: InterviewsService | InterviewsV2Service, user: MeUser, question: IQuestion, isSolOrDelivery: boolean, downloadLogService: DownloadLogService, payload: IPayload, withDateSort: boolean = true, section?: string) => {

  const showDownloadDeleted = section ? DOWNLOAD_DELETED_SECTIONS.includes(section.toUpperCase()) : false;

  let buttons = [];
  if (user.csiLevel == "HQ") {
    buttons = [new UploadExcelCommand<InterviewSummary, InterviewsService | InterviewsV2Service>(service, undefined, downloadLogService, payload),
    ...(showDownloadDeleted ? [new DownloadDeletedCommand<InterviewSummary, InterviewsV2Service>(service as InterviewsV2Service)] : []),
    new DownloadExcelCommand<InterviewSummary, InterviewsService | InterviewsV2Service>(service)]
  } else {
    buttons = [
      ...(showDownloadDeleted ? [new DownloadDeletedCommand<InterviewSummary, InterviewsV2Service>(service as InterviewsV2Service)] : []),
      new DownloadExcelCommand<InterviewSummary, InterviewsService | InterviewsV2Service>(service)
    ];
  }

  const INTERVIEW_SUMMARY_TABLE_CONFIG: TableStructure<any> = new TableStructure<any>(
    getColumns(user, question, service, isSolOrDelivery),
    "serverSide",
    [10, 20, 30],
    withDateSort ? { id: 'interviewdate', start: 'desc', disableClear: true } : undefined,
    true,
    buttons,
    [
      {
        filterBy: "NPS", options: ["All", "Promoters", "Neutrals", "Detractors"],
      },
      { filterBy: "channel", options: ["All", "Cawi", "Cati", "Cami", "Whatsapp"] },
      { filterBy: "recovery", options: ["All", 'Recovery'] },
    ]
  );

  if (question.section === "SHOPPER") {
    INTERVIEW_SUMMARY_TABLE_CONFIG.questionColumnsAnchor = "orderCustomerType";
  }

  return INTERVIEW_SUMMARY_TABLE_CONFIG;
};





